let baseURL;
baseURL = process.env.REACT_APP_BASE_URL_PROD;
export { baseURL };
